import { render } from "./p-button.vue?vue&type=template&id=7686c592&scoped=true"
import script from "./p-button.vue?vue&type=script&lang=js"
export * from "./p-button.vue?vue&type=script&lang=js"

import "./p-button.vue?vue&type=style&index=0&id=7686c592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7686c592"]])

export default __exports__